<h2 mat-dialog-title>Informações da pergunta</h2>
<mat-dialog-content>
    <form [formGroup]="formQuestion">

        <div class="row">
            <mat-form-field appearance="fill">
                <mat-label>Enunciado da pergunta</mat-label>
                <input matInput type="text" formControlName="descriptionQuestion" placeholder="Enunciado da pergunta" />
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field appearance="fill">
                <mat-label>Tipo da pergunta</mat-label>
                <mat-select matInput formControlName="questionType" placeholder="Tipo da pergunta">
                    <mat-option value="dissertative">Resposta dissertativa</mat-option>
                    <mat-option value="multiple">Múltipla escolha (Só uma alternativa é correta)</mat-option>
                    <mat-option value="option">Múltipla seleção (Uma ou mais alternativas corretas)</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-slide-toggle color="primary" formControlName="required">Pergunta obrigatória</mat-slide-toggle>
        </div>

        <fieldset *ngIf="formQuestion.get('questionType').value !== 'dissertative'" style="margin: 15px 0px">
            <legend>Opções</legend>

            <ng-container formArrayName="options">

                <ng-container *ngFor="let control of Options.controls; let i = index">

                    <div class="row" [formGroupName]="i" style="flex-direction: row;">
                        <mat-form-field appearance="fill" style="margin-bottom: 20px;">
                            <input matInput type="text" placeholder="Opção da pergunta" formControlName="name" />
                            <mat-hint><mat-slide-toggle color="primary" formControlName="isRight"></mat-slide-toggle> Marque se essa pergunta será a correta</mat-hint>
                        </mat-form-field>
                        <button mat-icon-button color="warn" (click)="removeOption(i)"
                            *ngIf="Options.controls.length > 1">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>

                </ng-container>

            </ng-container>

            <div class="actions" style="padding: 10px 0px;">
                <button mat-button color="primary" type="button" (click)="addOptions()">Adicionar opção</button>

            </div>

            <mat-divider></mat-divider>

        </fieldset>

    </form>
</mat-dialog-content>
<mat-progress-bar *ngIf="submiting"></mat-progress-bar>
<mat-dialog-actions *ngIf="!submiting">
    <button mat-button color="warn" type="button" mat-dialog-close>Cancelar</button>
    <button mat-raised-button color="primary" type="click" [disabled]="!isFormValid()"
        (click)="submitQuestion()">Salvar pergunta</button>
</mat-dialog-actions>